import { Exception } from 'app/api/exception/Exception';

/**
 * Исключение используется в случае ошибок соединения.
 * Возникает в случае обрыва соединения с сервером, интернетом и т.д.
 */
export class NetworkException extends Exception {
    static readonly NAME = 'NetworkException';

    private static readonly NETWORK_ERROR_MESSAGE =
        'Не удалось выполнить операцию. Попробуйте ещё раз позже';

    constructor() {
        super(
            NetworkException.NAME,
            NetworkException.NAME,
            NetworkException.NETWORK_ERROR_MESSAGE,
        );

        this.name = NetworkException.NAME;
    }
}
